module.exports = __webpack_public_path__ + "img/icon_img13.fa597e57.png";